module.exports = __webpack_public_path__ + "static/media/32.95327c61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/32.jpg
// module id = 292
// module chunks = 0